import { gql } from '@apollo/client';
import { questFragment } from '../fragments/quest';

export const getQuestsByIdsQuery = gql`
    ${questFragment}

    query GetQuestsByIds($ids: [String!]!) {
        questsByIds(ids: $ids) {
            ...QuestFields
        }
    }
`;
